import { combineReducers } from 'redux';
import profile from './profile';
import calculate from './calculate';
import material from './material';
import application from './application';

export default combineReducers({
  profile,
  calculate,
  material,
  application
});



// WEBPACK FOOTER //
// ./src/reducers/web-services/index.js